import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  MenuItem,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { DropzoneArea } from 'mui-file-dropzone';
import { useEffect, useState } from 'react';
import { PopupComponent } from 'src/components/common/PopupComponent';
import ProgressBar from 'src/components/common/ProgressBar';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import VersionControl from 'src/components/versionControl/VersionControl';
import { sendRequest } from 'src/hooks/useFetch';
import { setMessage } from 'src/store/Message';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { formatInput } from 'src/util/STR';
import './DocumentUpload.scss';
import { useDocumentUploads } from './useDocumentUploads';

interface stateDocs {
  type: string;
  level: string;
  open: boolean;
  setOpen: (active: boolean) => void;
  selectedSite: any;
  active: boolean;
  setActive: (active: boolean) => void;
  active2: boolean;
  setActive2: (active: boolean) => void;
  setDraftBtnDisplay?: any;
  setDraftBtnDisplay2?: any;
  getUploadedDocuments?: any;
  setProtocolSynopsisDoc?: any;
}

export const DocumentUpload = (props: stateDocs) => {
  const [isUpload, setIsUpload] = useState<boolean>(false);
  const [dfile, setDfile] = useState<any>(null);
  const [artifactName, setArtifactName] = useState<any>();
  const [resData, setResData] = useState<any>();
  const [enable, setEnable] = useState<boolean>(false);

  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const application = process.env.REACT_APP_NAME;
  const { createMasterDocumentEtmf, getAllDocsByArtifactName, getDocLevelByArtifactName, getTmfLevelQuery } =
    useDocumentUploads();
  const [styleUpload, setStyleUpload] = useState('uploadFile');
  const [error, setError] = useState<any>(null);
  const { duFileUploadErrorMsg, duDocumentUploadSuccessMsg, applicationModuleSection } = useFieldTranslation();
  const dispatch = useAppDispatch();
  const { preferedDateFormat, userPreferedDateFormat } = usePreferedDateFormat();
  const [openVersion, setOpenVersion] = useState(false);
  const [selectData, setSelectData] = useState<any>([]);

  const initialState = {
    tmf_artifact_number: '',
    tmf_document_name: '',
    tmf_doc_type: '',
    tmf_doc_subtype: '',
    tmf_doc_date: new Date().toISOString().split('T')[0],
    tmf_doc_country: '',
    tmf_doc_study: '',
    tmf_doc_site: '',
    tmf_doc_level: '',
    tmf_artifact_name: '',
    tmf_doc_version_number: 1,
    tmf_doc_milestone: ''
  };
  const [metaData, setMetaData] = useState<any>({
    ...initialState,
    tmf_doc_level: props.level,
    tmf_artifact_name: props.type
  });
  const [isLoading, setIsLoading] = useState(false);

  const useStyles = makeStyles(() =>
    createStyles({
      previewChip: {
        minWidth: 160,
        maxWidth: 210
      }
    })
  );

  const classes = useStyles();
  interface dataUpload {
    created_on: string;
    id: string;
    is_active: boolean;
    tmf_bucket_name: string;
    tmf_doc_created_by: string;
    tmf_doc_pages: string;
    tmf_doc_size: string;
    tmf_doc_type: string;
    tmf_doc_upload_date: string;
    tmf_doc_version_number: number;
    tmf_hashed_file_name: string;
    tmf_prefix: string;
    tmf_raw_file_name: string;
    updated_on: string;
  }

  const uploadFile = async (file: any): Promise<dataUpload> => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const options = {
        endPointEnv: 'etmf',
        data: formData,
        pathVariables: {
          study_id: studyId,
          country: selectedCountry,
          site_id: selectedSite,
          appName: application,
          module_section_related: applicationModuleSection.startupPacket,
          parent_entity_related: ''
        }
      };
      const response: any = await sendRequest('document_upload_doc_upload_file', options);
      return response;
    } catch {
      setIsLoading(false);
      dispatch(setMessage({ msgDetails: duFileUploadErrorMsg, severity: 'error' }));
      return Promise.reject();
    }
  };
  const uploadDataFile = async (): Promise<any> => {
    if (dfile) {
      const result = await uploadFile(dfile);
      if (result?.tmf_doc_version_number) {
        setResData(result);
        setMetaData({
          ...metaData,
          tmf_doc_version_number: result.tmf_doc_version_number,
          tmf_doc_date: result.updated_on,
          tmf_document_id: result.id
        });
        return result;
      } else {
        return false;
      }
    }
  };

  const handleUploadFile = async (Res: any, metaData: any, artifactName: any, isSubmit: boolean) => {
    const check = await uploadDataFile();
    if (!check) {
      return;
    }
    setError(null);
    const docData: any = {
      file_master_id: check.id,
      document_data: {
        tmf_artifact_number: metaData.tmf_artifact_number,
        tmf_document_name: metaData.tmf_document_name,
        tmf_doc_type: metaData.tmf_doc_type,
        tmf_doc_subtype: metaData.tmf_doc_subtype,
        tmf_doc_status: 'Uploaded',
        sent_to_isf: false,
        tmf_doc_country:
          metaData.tmf_doc_level === 'Country' || metaData.tmf_doc_level === 'Site' ? metaData.tmf_doc_country : null,
        tmf_doc_study: metaData.tmf_doc_study,
        tmf_doc_site: metaData.tmf_doc_level === 'Site' ? metaData.tmf_doc_site : null,
        tmf_doc_viewer_language: 'English',
        tmf_doc_viewer_approval_cycle: 0,
        tmf_doc_viewer_product_detail: 'string',
        tmf_doc_viewer_ref_model_version: 'TMF RM 3.2.1',
        tmf_doc_viewer_format: check.tmf_doc_type,
        tmf_doc_viewer_inspection_ready: 'string',
        tmf_doc_viewer_ir_issue_type: 'string',
        tmf_doc_level: metaData.tmf_doc_level,
        tmf_artifact_name: artifactName,
        tmf_doc_viewer_req_certified_copy: 'N',
        tmf_doc_viewer_department: 'None',
        tmf_doc_version_number: check.tmf_doc_version_number,
        tmf_doc_milestone: metaData.tmf_doc_milestone,

        tmf_doc_created_by: check.tmf_doc_created_by,
        tmf_document_id: 'str'
      }
    };
    getDocumentDetails(metaData, docData, isSubmit);
    setIsUpload(false);
  };
  // Get document details by artifact name with error handling
  const getDocumentDetails = async (metaData: any, docData: any, isSubmit: any) => {
    const country = metaData.tmf_doc_level === 'Study' ? '' : metaData.tmf_doc_country;
    const site =
      metaData.tmf_doc_level === 'Study' || metaData.tmf_doc_level === 'Country' ? '' : metaData.tmf_doc_site;
    const res: any = await getAllDocsByArtifactName({
      country,
      site_id: site,
      study_id: studyId,
      docLevel: metaData.tmf_doc_level,
      artifactName,
      application,
      module_section_related: applicationModuleSection.startupPacket,
      parent_entity_related: ''
    });
    if (res?.isSuccess) {
      const result: any = res?.data && res?.data.selected_data.length > 0 ? res?.data.selected_data : [];
      if (result.length > 0) {
        setSelectData(result[0]);
        (metaData.tmf_doc_level === result[0].document_data.tmf_doc_level &&
          metaData.tmf_doc_study === result[0].document_data.tmf_doc_study &&
          metaData.tmf_artifact_name === result[0].document_data.tmf_artifact_name) ||
        metaData.tmf_doc_country === result[0].document_data.tmf_doc_country ||
        metaData.tmf_doc_site === result[0].document_data.tmf_doc_site
          ? setOpenVersion(true)
          : postData(docData, isSubmit);
      }
    } else if (res?.error) {
      postData(docData, isSubmit);
      setDfile('');
      setIsUpload(false);
      setTimeout(() => {
        isSubmit && props.setOpen(false);
      }, 1500);
    }
  };

  const postData = async (docData: any, _: any) => {
    const response: any = await createMasterDocumentEtmf({
      data: docData,
      study_id: studyId,
      country: selectedCountry,
      site_id: selectedSite,
      application,
      module_section_related: applicationModuleSection.startupPacket,
      parent_entity_related: ''
    });
    if (response?.data) {
      dispatch(setMessage({ msgDetails: duDocumentUploadSuccessMsg, severity: 'success' }));
      props.getUploadedDocuments(props.type);
    } else if (response?.error) {
      if (response?.error.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (response?.error.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      } else {
        dispatch(setMessage({ msgDetails: duFileUploadErrorMsg, severity: 'error' }));
      }
    }
  };

  // setting study from selected study value
  const getStudy = async (_: any) => {
    setMetaData({ ...metaData, tmf_doc_study: studyId });
  };

  const handlechangeTmfLevel = (level: any) => {
    setMetaData({ ...metaData, tmf_doc_level: level });
    getTmfDataResponse(level);
  };

  const handleSiteChange = (e: any) => {
    setMetaData({ ...metaData, tmf_doc_site: e.target.value });
    getStudy(e);
  };

  const handleChangeArtifactName = (type: any = '', e: any = '') => {
    setMetaData({ ...metaData, tmf_artifact_name: type ? type : e.target.value });
    setArtifactName(type ? type : e.target.value);
    getArtifactNameResponse(type ? type : e.target.value);
  };

  const handleDocumentName = (e: any) => {
    const val = e.target.value;
    const formattedVal = typeof val === 'string' ? formatInput(val) : val;
    setMetaData({ ...metaData, tmf_document_name: formattedVal });
  };

  const callFunctions = async () => {
    handlechangeTmfLevel(props.level);
    handleChangeArtifactName(props.type);
  };

  useEffect(() => {
    if (props.type) {
      callFunctions();
    }
  }, [props]);

  useEffect(() => {
    if (isUpload) {
      if (error) {
        setStyleUpload('uploadFileError');
      } else {
        setStyleUpload('uploadFileSuccess');
      }
    } else {
      setStyleUpload('uploadFile withFakeBtn');
    }
  }, [isUpload, error]);

  useEffect(() => {
    if (dfile) {
      const eleButton = document.getElementsByTagName('input');
      for (let i = 0; i < eleButton.length; i++) {
        if (eleButton[i].type === 'file') {
          const eleFile = eleButton[i] as HTMLElement;
          eleFile.style.cssText = 'display: none!important';
        }
      }
    }
  }, [dfile]);

  // Get Artifact details based on doc level and artifact name
  const getArtifactNameResponse = async (type: any) => {
    setIsLoading(true);
    const result: any = await getDocLevelByArtifactName({
      tmf_doc_level: metaData.tmf_doc_level,
      tmf_artifact_name: type,
      study_id: studyId,
      country: selectedCountry,
      site_id: selectedSite,
      application,
      module_section_related: applicationModuleSection.startupPacket,
      parent_entity_related: ''
    });
    if (result?.data) {
      setMetaData({
        ...metaData,
        tmf_artifact_number: result?.data.tmf_artifact_number,
        tmf_doc_subtype: result?.data.tmf_doc_subtype,
        tmf_doc_type: result?.data.tmf_doc_type,
        tmf_doc_milestone: result?.data.tmf_doc_milestone,
        tmf_doc_site: selectedSite,
        tmf_doc_country: selectedCountry,
        tmf_doc_study: studyId
      });
    } else if (result?.error) {
      if (result?.error.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (result?.error.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (dfile) {
      setIsUpload(true);
    } else {
      setIsUpload(false);
    }
  }, [dfile]);

  // getting artifact names and error handling for 401 and 403
  const getTmfDataResponse = async (level: any) => {
    setIsLoading(true);
    const result: any = await getTmfLevelQuery({
      tmf_level: level,
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application,
      module_section_related: applicationModuleSection.startupPacket,
      parent_entity_related: ''
    });
    if (result?.error) {
      if (result?.error.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (result?.error.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
    }
    setIsLoading(false);
  };
  const handleCloseVersion = () => {
    setOpenVersion(false);
    setDfile('');
    setIsUpload(false);
    setMetaData({ ...initialState });
    setTimeout(() => {
      props.setOpen(false);
    }, 1500);
  };

  const handleBackVersion = () => {
    setOpenVersion(false);
    setIsUpload(true);
  };
  const clearData = () => {
    setDfile('');
    setIsUpload(false);
    setMetaData({ ...initialState });
    props.setOpen(false);
  };

  const handleRejectedMessage = (rejectedFile: any, acceptedFiles: any, maxFileSize: any) => {
    let message = `${rejectedFile.name} cannot be uploaded! , `;
    const arrFile = rejectedFile.name.split('.');
    if (!acceptedFiles.includes(`.${arrFile[arrFile.length - 1]}`)) {
      message += `File Format is not supported`;
    } else if (rejectedFile.size > maxFileSize) {
      message += `File Size more than 5MB is not allowed.`;
    }
    // setError(message);
    return message;
  };
  const handleDialoBox = () => {
    setEnable(true);
  };
  const handleClose = () => {
    setEnable(false);
  };

  const handleFileChange = (files: any) => {
    if (files && files.length) {
      setDfile(files[0]);
      dispatch(
        setMessage({ msgDetails: `Your file ${files?.[0]?.name} has been successfully uploaded.`, severity: 'success' })
      );
    }
  };

  return (
    <div className="document-upload-page">
      <div className="card">
        <Grid container spacing={3}>
          <Grid item md={12}>
            <div id="uploadFile" className={styleUpload}>
              <DropzoneArea
                fileObjects={[]}
                showPreviewsInDropzone={isUpload}
                filesLimit={1}
                maxFileSize={5000000}
                acceptedFiles={[
                  '.jpg',
                  '.jpeg',
                  '.gif',
                  '.png',
                  '.bmp',
                  '.tif',
                  '.tiff',
                  '.psd',
                  '.pdf',
                  '.doc',
                  '.docx',
                  '.xls',
                  '.xlsx'
                ]}
                useChipsForPreview
                showFileNames={false}
                showAlerts={['error', 'info']}
                dropzoneText={
                  isUpload ? 'Your file upload has been successfully initiated' : `Drag and drop your file here or`
                }
                previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                previewChipProps={{ classes: { root: classes.previewChip } }}
                previewText="Selected files"
                //onChange={e => setDfile(e[0])}
                onChange={e => handleFileChange(e)}
                getFileLimitExceedMessage={(_: number) =>
                  'You cannot upload more than one file at once. Please try with single file'
                }
                getDropRejectMessage={handleRejectedMessage}
              />
              <Typography
                variant="body2"
                display="block"
                gutterBottom
                color="text.secondary"
                sx={{ mt: -4, textAlign: 'center', position: 'relative', zIndex: 12 }}
              >
                <strong>Accepted file type:&nbsp;</strong>
                {[
                  '.jpg',
                  '.jpeg',
                  '.gif',
                  '.png',
                  '.bmp',
                  '.tif',
                  '.tiff',
                  '.psd',
                  '.pdf',
                  '.doc',
                  '.docx',
                  '.xls',
                  '.xlsx'
                ].toString()}
              </Typography>
            </div>
          </Grid>
          {isLoading && <ProgressBar />}
          <Grid item md={12}>
            <Grid container spacing={2}>
              <Grid item md={4}>
                <FormControl fullWidth margin="normal">
                  <TextField
                    required
                    disabled={!isUpload}
                    id="standard-select-currency-native"
                    label="Document Name "
                    variant="standard"
                    value={metaData.tmf_document_name}
                    inputProps={{
                      maxLength: 200
                    }}
                    onChange={e => handleDocumentName(e)}
                  />
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    required={metaData.tmf_doc_level === 'Country' || metaData.tmf_doc_level === 'Site'}
                    id="standard-select-currency-native"
                    select
                    label="Country"
                    defaultValue=""
                    value={metaData.tmf_doc_level === 'Study' ? '' : metaData.tmf_doc_country}
                    variant="standard"
                  >
                    <MenuItem value={metaData.tmf_doc_country}>{metaData.tmf_doc_country}</MenuItem>
                  </TextField>
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    label="Version Number"
                    variant="standard"
                    value={isUpload ? parseFloat(metaData.tmf_doc_version_number).toFixed(1) : ''}
                  />
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    id="standard-select-currency-native"
                    label="Subtype"
                    variant="standard"
                    value={metaData.tmf_doc_subtype}
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={4}>
                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-required"
                    select
                    label="TMF Level"
                    defaultValue=""
                    value={metaData.tmf_doc_level}
                    variant="standard"
                    onChange={e => {
                      handlechangeTmfLevel(e.target.value);
                    }}
                  >
                    <MenuItem value="Study">Study</MenuItem>
                    <MenuItem value="Country">Country</MenuItem>
                    <MenuItem value="Site">Site</MenuItem>
                  </TextField>
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    required={metaData.tmf_doc_level === 'Site'}
                    id="standard-select-currency-native"
                    select
                    value={
                      metaData.tmf_doc_level === 'Study' || metaData.tmf_doc_level === 'Country'
                        ? ''
                        : metaData.tmf_doc_site
                    }
                    label="Site"
                    variant="standard"
                    onChange={e => {
                      handleSiteChange(e);
                    }}
                  >
                    <MenuItem value={metaData.tmf_doc_site}>{metaData.tmf_doc_site}</MenuItem>
                  </TextField>
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    id="standard-select-currency-native"
                    label="Milestone"
                    variant="standard"
                    value={metaData.tmf_doc_milestone}
                    disabled
                  />
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    id="standard-select-currency-native"
                    label="Artifact Number"
                    variant="standard"
                    value={metaData.tmf_artifact_number}
                    disabled
                  />
                </FormControl>
              </Grid>
              <Grid item md={4}>
                <FormControl fullWidth margin="normal">
                  <TextField
                    id="standard-select-currency-native"
                    label="Study"
                    disabled
                    variant="standard"
                    value={studyId}
                  />
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-required"
                    select
                    required
                    label="Artifact Name"
                    variant="standard"
                    value={metaData.tmf_artifact_name ? metaData.tmf_artifact_name : ''}
                  >
                    <MenuItem value={metaData.tmf_artifact_name}>{metaData.tmf_artifact_name}</MenuItem>
                  </TextField>
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    id="standard-select-currency-native"
                    label="Type"
                    variant="standard"
                    value={metaData.tmf_doc_type}
                    disabled
                  />
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    label="Upload Date"
                    variant="standard"
                    placeholder={userPreferedDateFormat.toLowerCase()}
                    type={isUpload ? 'text' : ''}
                    value={isUpload ? preferedDateFormat(metaData.tmf_doc_date.split('T')[0]) : ''}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item md={12} display="flex" justifyContent="flex-end">
                <Stack direction="row" spacing={2}>
                  <Button href="#contained-buttons" className="grey-btn" onClick={handleDialoBox}>
                    Cancel
                  </Button>
                  <PopupComponent
                    open={enable}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    child
                  >
                    <DialogTitle id="alert-dialog-title">{'Cancel Document Upload'}</DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Are you sure you want to cancel uploading this document?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={clearData} autoFocus className="grey-btn">
                        Yes
                      </Button>
                      <Button onClick={handleClose}>No</Button>
                    </DialogActions>
                  </PopupComponent>
                  <Button
                    onClick={() => handleUploadFile(resData, metaData, artifactName, true)}
                    disabled={
                      !dfile || !metaData.tmf_doc_level || !metaData.tmf_artifact_number || !metaData.tmf_document_name
                    }
                  >
                    Submit
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      {openVersion && (
        <PopupComponent maxWidth="sm" open={openVersion} child>
          <VersionControl
            resData={resData}
            metaData={metaData}
            selectData={selectData}
            setSelectData={setSelectData}
            setMetaData={setMetaData}
            handleCloseVersion={handleCloseVersion}
            handleBackVersion={handleBackVersion}
            artifactName={artifactName}
            getUploadedDocuments={props.getUploadedDocuments}
          />
        </PopupComponent>
      )}
    </div>
  );
};
